/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FrotaListComponent } from "./frota-list/frota-list.component";
import { FrotaFormComponent } from "./frota-form/frota-form.component";
import { editRoute, newRoute, detailRoute } from "../../shared/services/data.service";
import {
    veiculosRoute, aeronavesRoute, embarcacoesRoute, equipamentosRoute,
    maquinarioRoute, outrosRoute
} from "./shared/data.service";
import { FrotaDetailComponent } from "./frota-detail/frota-detail.component";
import {abastecimentoBensRoute} from "../../abastecimentos/abastecimento-bens/shared/data.service";
import {AbastecimentoBemListComponent} from "../../abastecimentos/abastecimento-bens/abastecimento-bem-list/abastecimento-bem-list.component";
import {AbastecimentoBemFormComponent} from "../../abastecimentos/abastecimento-bens/abastecimento-bem-form/abastecimento-bem-form.component";
import {ordensServicoRoute} from "../../manutencoes/ordens-servico/shared/data.service";
import {OrdemServicoListComponent} from "../../manutencoes/ordens-servico/ordem-servico-list/ordem-servico-list.component";
import {OrdemServicosFormComponent} from "../../manutencoes/ordens-servico/ordem-servico-form/ordem-servico-form.component";
import {OrdemServicoDetailComponent} from "../../manutencoes/ordens-servico/ordem-servico-detail/ordem-servico-detail.component";
import {planosRoute} from "../../manutencoes/planos/shared/data.service";
import {ServicoBemListComponent} from "../../manutencoes/servicos/servico-bens/servico-bem-list/servico-bem-list.component";
import {FrotaImagemComponent} from "./frota-imagem/frota-imagem.component";
import {FrotaOdometroHorimetroComponent} from "./frota-odometro-horimetro/frota-odometro-horimetro.component";
import {deslocamentosRoute} from "../../viagens/deslocamentos/shared/data.service";
import {DeslocamentoHistoryComponent} from "../../viagens/deslocamentos/deslocamento-history/deslocamento-history.component";

@NgModule({
    imports: [
        RouterModule.forChild([])
    ],
    exports: [
        RouterModule
    ]
})
export class FrotasRoutingModule {}


export const frotasRoutes: any[] = [
    {
        path: veiculosRoute,
        component: FrotaListComponent
    },{
        path: veiculosRoute + '/' + editRoute + '/:id',
        component: FrotaFormComponent
    },{
        path: veiculosRoute + '/' + newRoute,
        component: FrotaFormComponent
    },{
        path: veiculosRoute + '/' + detailRoute + '/:id',
        component: FrotaDetailComponent
    },{
        path: veiculosRoute + '/fotos/:id',
        component: FrotaImagemComponent
    },{
        path: veiculosRoute + '/odometro-horimetro/:id',
        component: FrotaOdometroHorimetroComponent
    },{
        path: veiculosRoute + '/' + abastecimentoBensRoute,
        component: AbastecimentoBemListComponent
    },{
        path: veiculosRoute + '/' + abastecimentoBensRoute + '/' + newRoute,
        component: AbastecimentoBemFormComponent
    },{
        path: veiculosRoute + '/' + abastecimentoBensRoute + '/' + editRoute + '/:id',
        component: AbastecimentoBemFormComponent
    },{
        path: veiculosRoute + '/' + ordensServicoRoute,
        component: OrdemServicoListComponent
    },{
        path: veiculosRoute + '/' + ordensServicoRoute + '/' + newRoute,
        component: OrdemServicosFormComponent
    },{
        path: veiculosRoute + '/' + ordensServicoRoute + '/' + editRoute + '/:id',
        component: OrdemServicosFormComponent
    },{
        path: veiculosRoute + '/' + ordensServicoRoute + '/' + detailRoute + '/:id',
        component: OrdemServicoDetailComponent
    },{
        path: veiculosRoute + '/' + planosRoute,
        component: ServicoBemListComponent
    },{
        path: veiculosRoute + '/' + deslocamentosRoute + '/historico',
        component: DeslocamentoHistoryComponent
    },
    {
        path: aeronavesRoute,
        component: FrotaListComponent
    },{
        path: aeronavesRoute + '/' + editRoute + '/:id',
        component: FrotaFormComponent
    },{
        path: aeronavesRoute + '/' + newRoute,
        component: FrotaFormComponent
    },{
        path: aeronavesRoute + '/' + detailRoute + '/:id',
        component: FrotaDetailComponent
    },{
        path: aeronavesRoute + '/fotos/:id',
        component: FrotaImagemComponent
    },{
        path: aeronavesRoute + '/odometro-horimetro/:id',
        component: FrotaOdometroHorimetroComponent
    },{
        path: aeronavesRoute + '/' + abastecimentoBensRoute,
        component: AbastecimentoBemListComponent
    },{
        path: aeronavesRoute + '/' + abastecimentoBensRoute + '/' + newRoute,
        component: AbastecimentoBemFormComponent
    },{
        path: aeronavesRoute + '/' + abastecimentoBensRoute + '/' + editRoute + '/:id',
        component: AbastecimentoBemFormComponent
    },{
        path: aeronavesRoute + '/' + ordensServicoRoute,
        component: OrdemServicoListComponent
    },{
        path: aeronavesRoute + '/' + ordensServicoRoute + '/' + newRoute,
        component: OrdemServicosFormComponent
    },{
        path: aeronavesRoute + '/' + ordensServicoRoute + '/' + editRoute + '/:id',
        component: OrdemServicosFormComponent
    },{
        path: aeronavesRoute + '/' + ordensServicoRoute + '/' + detailRoute + '/:id',
        component: OrdemServicoDetailComponent
    },{
        path: aeronavesRoute + '/' + planosRoute,
        component: ServicoBemListComponent
    },{
        path: aeronavesRoute + '/' + deslocamentosRoute + '/historico',
        component: DeslocamentoHistoryComponent
    },
    {
        path: embarcacoesRoute,
        component: FrotaListComponent
    },{
        path: embarcacoesRoute + '/' + editRoute + '/:id',
        component: FrotaFormComponent
    },{
        path: embarcacoesRoute + '/' + newRoute,
        component: FrotaFormComponent
    },{
        path: embarcacoesRoute + '/' + detailRoute + '/:id',
        component: FrotaDetailComponent
    },{
        path: embarcacoesRoute + '/fotos/:id',
        component: FrotaImagemComponent
    },{
        path: embarcacoesRoute + '/odometro-horimetro/:id',
        component: FrotaOdometroHorimetroComponent
    },{
        path: embarcacoesRoute + '/' + abastecimentoBensRoute,
        component: AbastecimentoBemListComponent
    },{
        path: embarcacoesRoute + '/' + abastecimentoBensRoute + '/' + newRoute,
        component: AbastecimentoBemFormComponent
    },{
        path: embarcacoesRoute + '/' + abastecimentoBensRoute + '/' + editRoute + '/:id',
        component: AbastecimentoBemFormComponent
    },{
        path: embarcacoesRoute + '/' + ordensServicoRoute,
        component: OrdemServicoListComponent
    },{
        path: embarcacoesRoute + '/' + ordensServicoRoute + '/' + newRoute,
        component: OrdemServicosFormComponent
    },{
        path: embarcacoesRoute + '/' + ordensServicoRoute + '/' + editRoute + '/:id',
        component: OrdemServicosFormComponent
    },{
        path: embarcacoesRoute + '/' + ordensServicoRoute + '/' + detailRoute + '/:id',
        component: OrdemServicoDetailComponent
    },{
        path: embarcacoesRoute + '/' + planosRoute,
        component: ServicoBemListComponent
    },{
        path: embarcacoesRoute + '/' + deslocamentosRoute + '/historico',
        component: DeslocamentoHistoryComponent
    },
    {
        path: equipamentosRoute,
        component: FrotaListComponent
    },{
        path: equipamentosRoute + '/' + editRoute + '/:id',
        component: FrotaFormComponent
    },{
        path: equipamentosRoute + '/' + newRoute,
        component: FrotaFormComponent
    },{
        path: equipamentosRoute + '/' + detailRoute + '/:id',
        component: FrotaDetailComponent
    },{
        path: equipamentosRoute + '/fotos/:id',
        component: FrotaImagemComponent
    },{
        path: equipamentosRoute + '/odometro-horimetro/:id',
        component: FrotaOdometroHorimetroComponent
    },{
        path: equipamentosRoute + '/' + abastecimentoBensRoute,
        component: AbastecimentoBemListComponent
    },{
        path: equipamentosRoute + '/' + abastecimentoBensRoute + '/' + newRoute,
        component: AbastecimentoBemFormComponent
    },{
        path: equipamentosRoute + '/' + abastecimentoBensRoute + '/' + editRoute + '/:id',
        component: AbastecimentoBemFormComponent
    },{
        path: equipamentosRoute + '/' + ordensServicoRoute,
        component: OrdemServicoListComponent
    },{
        path: equipamentosRoute + '/' + ordensServicoRoute + '/' + newRoute,
        component: OrdemServicosFormComponent
    },{
        path: equipamentosRoute + '/' + ordensServicoRoute + '/' + editRoute + '/:id',
        component: OrdemServicosFormComponent
    },{
        path: equipamentosRoute + '/' + ordensServicoRoute + '/' + detailRoute + '/:id',
        component: OrdemServicoDetailComponent
    },{
        path: equipamentosRoute + '/' + planosRoute,
        component: ServicoBemListComponent
    },{
        path: equipamentosRoute + '/' + deslocamentosRoute + '/historico',
        component: DeslocamentoHistoryComponent
    },
    {
        path: maquinarioRoute,
        component: FrotaListComponent
    },{
        path: maquinarioRoute + '/' + editRoute + '/:id',
        component: FrotaFormComponent
    },{
        path: maquinarioRoute + '/' + newRoute,
        component: FrotaFormComponent
    },{
        path: maquinarioRoute + '/' + detailRoute + '/:id',
        component: FrotaDetailComponent
    },{
        path: maquinarioRoute + '/fotos/:id',
        component: FrotaImagemComponent
    },{
        path: maquinarioRoute + '/odometro-horimetro/:id',
        component: FrotaOdometroHorimetroComponent
    },{
        path: maquinarioRoute + '/' + abastecimentoBensRoute,
        component: AbastecimentoBemListComponent
    },{
        path: maquinarioRoute + '/' + abastecimentoBensRoute + '/' + newRoute,
        component: AbastecimentoBemFormComponent
    },{
        path: maquinarioRoute + '/' + abastecimentoBensRoute + '/' + editRoute + '/:id',
        component: AbastecimentoBemFormComponent
    },{
        path: maquinarioRoute + '/' + ordensServicoRoute,
        component: OrdemServicoListComponent
    },{
        path: maquinarioRoute + '/' + ordensServicoRoute + '/' + newRoute,
        component: OrdemServicosFormComponent
    },{
        path: maquinarioRoute + '/' + ordensServicoRoute + '/' + editRoute + '/:id',
        component: OrdemServicosFormComponent
    },{
        path: maquinarioRoute + '/' + ordensServicoRoute + '/' + detailRoute + '/:id',
        component: OrdemServicoDetailComponent
    },{
        path: maquinarioRoute + '/' + planosRoute,
        component: ServicoBemListComponent
    },{
        path: maquinarioRoute + '/' + deslocamentosRoute + '/historico',
        component: DeslocamentoHistoryComponent
    },
    {
        path: outrosRoute,
        component: FrotaListComponent
    },{
        path: outrosRoute + '/' + editRoute + '/:id',
        component: FrotaFormComponent
    },{
        path: outrosRoute + '/' + newRoute,
        component: FrotaFormComponent
    },{
        path: outrosRoute + '/' + detailRoute + '/:id',
        component: FrotaDetailComponent
    },{
        path: outrosRoute + '/fotos/:id',
        component: FrotaImagemComponent
    },{
        path: outrosRoute + '/odometro-horimetro/:id',
        component: FrotaOdometroHorimetroComponent
    },{
        path: outrosRoute + '/' + abastecimentoBensRoute,
        component: AbastecimentoBemListComponent
    },{
        path: outrosRoute + '/' + abastecimentoBensRoute + '/' + newRoute,
        component: AbastecimentoBemFormComponent
    },{
        path: outrosRoute + '/' + abastecimentoBensRoute + '/' + editRoute + '/:id',
        component: AbastecimentoBemFormComponent
    },{
        path: outrosRoute + '/' + ordensServicoRoute,
        component: OrdemServicoListComponent
    },{
        path: outrosRoute + '/' + ordensServicoRoute + '/' + newRoute,
        component: OrdemServicosFormComponent
    },{
        path: outrosRoute + '/' + ordensServicoRoute + '/' + editRoute + '/:id',
        component: OrdemServicosFormComponent
    }, {
        path: outrosRoute + '/' + ordensServicoRoute + '/' + detailRoute + '/:id',
        component: OrdemServicoDetailComponent
    },{
        path: outrosRoute + '/' + planosRoute,
        component: ServicoBemListComponent
    },{
        path: outrosRoute + '/' + deslocamentosRoute + '/historico',
        component: DeslocamentoHistoryComponent
    }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/frotas/frotas-routing.module.ts
 **/